<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Общая информация
        </h4>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Название сезона"
              >
                <b-form-input
                  v-model="season.name"
                  placeholder="Название сезона"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Сезон по умолчанию для новых стартов"
              >
                <b-form-checkbox
                  v-model="season.is_primary"
                  checked="false"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

    </div>

    <b-col>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mr-1 save-button"
        :disabled="isloading"
        @click="saveItem"
      >
        <b-spinner
          v-if="isloading"
          small
        />
        {{ isloading ? 'Сохранение...' : 'Сохранить' }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
  BFormCheckbox,
  VBPopover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Russian } from 'flatpickr/dist/l10n/ru'
import crud_module from '../../../libs/crud_module'

const season_module = crud_module({
  entity_name: 'season',
})

export default {

  name: 'CategoryPage',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    BFormCheckbox,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      config: {
        allowInput: true,
        altFormat: 'd.m.Y H:i',
        altInput: true,
        enableTime: true,
        dateFormat: 'Z',
        locale: Russian, // locale for this instance only
      },
      isloading: false,
      downloadDisabled: false,
      season: {},
      textError: '',
    }
  },
  watch: {

  },
  async created() {
    if (this.$route.params.id === 'new') {
      return
    }
    try {
      await season_module.fetchItem(this.$route.params.id, {
        query: {
          admin: '1',
        },
      }).then(result => this.season = result.data)
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    saveItem() {
      if (this.$route.params.id === 'new') {
        this.create()
      } else {
        this.update()
      }
    },
    async update() {
      try {
        await season_module.updateItem(this.season.id, this.season)
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Сезон сохранен',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'seasons' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (error) {
        console.log(error)
        this.isloading = false
      }
    },
    async create() {
      try {
        await season_module.createItem(this.season)
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Сезон добавлен',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'seasons' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
